import Vue from 'vue'
import App from './App.vue'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import axios from 'axios'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueRouter from 'vue-router'
import store from './store/store'

Vue.config.productionTip = false
Vue.prototype.$http = axios

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(VueRouter)

import Sign from './components/Sign.vue';
import Ack from './components/Ack.vue';
import NotFound from './components/NotFound.vue';

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    { path: '/sign/:token', component: Sign },
    { path: '/ack', component: Ack },
    { path: '/404', component: NotFound },
    { path: '*', redirect: '/404' },

  ]
});

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
